module.exports = __webpack_public_path__ + "img/chat-banner.abfe95cb.png";